import { render, staticRenderFns } from "./PurchaseInfosHeader.vue?vue&type=template&id=1a3c2915&"
import script from "./PurchaseInfosHeader.vue?vue&type=script&lang=ts&"
export * from "./PurchaseInfosHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseInfosHeader.vue?vue&type=style&index=0&id=1a3c2915&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports